export default __webpack_public_path__ + "static/media/time-station-button.05f82ae7.png";